import { Box, Button, DialogActions, DialogContent, DialogTitle, Popover, PopoverProps } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { ConfirmationDialogState } from "contexts/ConfirmationDialogContext";
import { P } from "theme/typography";

const ConfirmationDialog = (cdSt: ConfirmationDialogState) => {
  const popover = cdSt.usePopover;

  const onPopoverClose: PopoverProps["onClose"] = (_, reason) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") {
      return;
    }
    cdSt.onCancel();
  };

  return popover ? (
    <Popover
      open={popover.isOpen}
      anchorEl={popover.anchorEl}
      onClose={onPopoverClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      {...popover.popoverProps}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, p: 2 }}>
        <P variant="baseBold">{cdSt.title}</P>
        <Box>{cdSt.prompt}</Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
          <Button
            onClick={() => {
              popover.onPopoverClose();
              cdSt.onCancel();
            }}
            {...cdSt.cancelButtonProps}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              cdSt.onConfirm();
              popover.onPopoverClose();
            }}
            {...cdSt.confirmButtonProps}>
            {cdSt.confirmButtonText || "Ok"}
          </Button>
        </Box>
      </Box>
    </Popover>
  ) : (
    <Dialog open={cdSt.open}>
      <DialogTitle>{cdSt.title}</DialogTitle>
      <DialogContent>{cdSt.prompt}</DialogContent>
      <DialogActions>
        <Button disabled={cdSt.confirming} onClick={cdSt.onCancel} {...cdSt.cancelButtonProps}>
          Cancel
        </Button>
        <Button disabled={cdSt.confirming} variant="contained" onClick={cdSt.onConfirm} {...cdSt.confirmButtonProps}>
          {cdSt.confirmButtonText || "Ok"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
